const pagesTitles = {
  adminsManagement: 'إدارة المسؤولين',
  admins: 'قائمة المسؤولين',
  adminsAdd: 'إضافة مسؤول جديد',
  adminsEdit: 'تعديل مسؤول',
  categoriesManagement: 'إدارة فئات مقدمى الخدمات',
  serviceProviderCategories: 'قائمة الفئات',
  serviceProviderCategoriesAdd: 'إضافة فئة جديدة',
  serviceProviderCategoriesEdit: 'تعديل فئة',
  serviceProviderCategoriesView: 'تفاصيل الفئة',
  specialtiesManagement: 'إدارة التخصصات',
  specialties: 'التخصصات',
  specialtiesAdd: 'إضافة تخصص جديد',
  specialtiesEdit: 'تعديل تخصص',
  specialtiesView: 'تفاصيل التخصص',
  servicesManagement: 'إدارة الخدمات',
  services: 'الخدمات',
  servicesAdd: 'إضافة خدمة جديدة',
  servicesEdit: 'تعديل خدمة',
  lookupsManagement:'إدارة العمليات',
  lookupsRequests:'طلبات العمليات',
  serviceProvidersManagement: 'إدارة مقدمي الخدمات',
  branchesManagement: 'إدارة الفروع',
  serviceProviders: 'مقدمي الخدمات',
  serviceProvidersAdd: 'إضافة مقدم خدمة',
  serviceProvidersEdit: 'تعديل مقدم خدمة',
  serviceProvidersView: 'تفاصيل مقدم خدمة',
  branchManagement: 'إدارة الفروع ',
  branches: 'قائمة الفروع',
  publishRequests: ' طلبات النشر ',
  bookings: 'قائمة الحجوزات',
  bookingsManagement: 'إدارة الحجوزات',
  addProviderBranch: 'إضافة فرع جديد',
  editProviderBranch: 'تعديل تفاصيل الفرع',
  editProviderBranchServicesAndSpecialties: 'تعديل خدمات وتخصصات الفرع',
  editProviderBranchEmployee: 'تعديل موظفي الفرع',
  employeesManagement: 'إدارة الموظفين',
  customersManagement: 'إدارة العملاء',
  employees: 'قائمة الموظفين',
  customers: 'قائمة العملاء',
  employeesAdd: 'إضافة موظف جديد',
  employeesEdit: 'تعديل موظف',
  AddBranch: 'إضافة فرع جديد',
  editBranch:'تعديل فرع',
  viewBranch: 'تفاصيل الفرع',
  branchTabOne: 'تفاصيل الفرع',
  branchTabTwo: 'تخصصات وخدمات الفرع',
  branchTabThree: 'موظفي الفرع',
  branchTabFour: 'قائمة الحجوزات',
  SupportedRegions: 'مناطق التغطية',
  SelectLocationFromMap: 'حدد الموقع من الخريطة',
  addProviderBranchSpecialties: 'التخصصات والخدمات',
  addProviderBranchEmployees: 'الموظفين',
  SettingsManagment:'الإعدادات',
  employeeView: 'تفاصيل الموظف',
  notificationsManagement:'إدارة الإشعارات',
  paymentTransactionsManagement:'إدارة معاملات الدفع',
  paymentTransactions:'قائمة معاملات الدفع',
  settlementsManagement: 'إدارة التسويات',
  settlements: 'قائمة التسويات',
  mimarProfit: 'أرباح ميمار',
  profitOverview: 'معاينة الأرباح',
};

export default pagesTitles;
